import React, { useState, useEffect } from "react";
import {
  ButtonHLPure,
  DialogSystemGLPure,
  DropDownBtnHLPure,
  SubtitlePageHLPure,
  CheckBoxDownHLPure
} from "../../../pures";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { profileIconDefault } from "../../../../assets/logos/icons";
import "./user-administration-enterprise-assign.view.css";

const UserAdministrationEnterpriseView = ({
  hideShowDetails,
  companiesRolesByUser,
  rolesBySignatureProfile,
  saveNewCompaniesRolesForUser,
  selectedUser,
  token,
  showDetailComponent,
  toggleShowDetailComponent,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
  allPermissions,
  toggleCompleteCloseDialog,
  showWarningRequesting,
  toggleWarningRequesting,
  userWithRoles
}) => {
  const [listOptions, setListOptions] = useState([
    // { id: 0, name: "Sin acceso" },
  ]);
  // const [company, setCompany] = useState(
  //   listOptions[0].name
  // );
  const [companiesRolesByUserState, setCompaniesRolesByUserState] = useState();
  const [forceRenderKey, setForceRenderKey] = useState(0)
  const { t } = useTranslation();
  useEffect(() => {
    setOptionsOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setOptionsOrder = () => {
    rolesBySignatureProfile.rolesLevelsBoveda.map((rolContrato) => {
      if (rolContrato.name === "Sin acceso bóveda") {
        rolContrato.name = rolContrato.name.substr(0, 10);
      }
      return rolesBySignatureProfile;
    });
    listOptions.push(...rolesBySignatureProfile.rolesLevelsBoveda);
    setListOptions(listOptions);
  };

  useEffect(() => {
    if (Object.keys(companiesRolesByUser).length !== 0) {
      setCompanyByUserState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companiesRolesByUser, allPermissions]);

  const setCompanyByUserState = () => {
    let finalArr = companiesRolesByUser.map((item) => {
      if (item.roleName === process.env.REACT_APP_DIGITAL_VAULT_ROLE_NAME_ADMIN) item.roleName = process.env.REACT_APP_DIGITAL_VAULT_ROLE_SHORT_NAME_ADMIN
      let permisos = allPermissions.find((role) => role.roleId === item.roleId)
      if (permisos) item.permissions = permisos.permissions
      return item
    });

    setCompaniesRolesByUserState(finalArr);
  };

  const handleDropDownChange = (e, dropdownCompany) => {
    const selectedRoleId = Number(e.target.value)
    const ENV = process.env

    const ADMIN_ROLE = +ENV.REACT_APP_COMPANY_ROLE_ID_ADMIN
    const NO_ACCESS_ROLE = +ENV.REACT_APP_COMPANY_ROLE_ID_NO_ACCESS
    const LEVEL_ROLES = [
      +ENV.REACT_APP_COMPANY_ROLE_ID_N1,
      +ENV.REACT_APP_COMPANY_ROLE_ID_N2,
      +ENV.REACT_APP_COMPANY_ROLE_ID_N3,
      +ENV.REACT_APP_COMPANY_ROLE_ID_N4,
      +ENV.REACT_APP_COMPANY_ROLE_ID_N5
    ]

    if (dropdownCompany.isExclusive) {
      if (dropdownCompany.noUsers && selectedRoleId !== ADMIN_ROLE) {
        toggleWarningRequesting(true, t('userAdministrationEnterpriseView.warnings.exclusive.noUsersMustBeAdmin'))
        setForceRenderKey(prev => prev + 1)
        return
      }

      const isAdminOrLevelRole = selectedRoleId === ADMIN_ROLE || LEVEL_ROLES.includes(selectedRoleId);

      if (isAdminOrLevelRole) {
        if (userWithRoles.rolesGovo.key === ENV.REACT_APP_ADMIN) {
          toggleWarningRequesting(true, t('userAdministrationEnterpriseView.warnings.exclusive.superAdminNotAllowed'))
          setForceRenderKey(prev => prev + 1)
          return
        }

        if (userWithRoles.rolesVault.key === ENV.REACT_APP_ADMIN_DIGITAL_VAULT) {
          toggleWarningRequesting(true, t('userAdministrationEnterpriseView.warnings.exclusive.vaultAdminNotAllowed'))
          setForceRenderKey(prev => prev + 1)
          return
        }

        if (userWithRoles.rolesVault.key === ENV.REACT_APP_NOT_ACCESS_DIGITAL_VAULT) {
          toggleWarningRequesting(true, t('userAdministrationEnterpriseView.warnings.exclusive.vaultViewRequired'))
          setForceRenderKey(prev => prev + 1)
          return
        }
      }
    }

    let selectedRolId = listOptions.find(
      (option) => option.id === selectedRoleId
    );

    let updateRolesCompaniesState = companiesRolesByUserState.map((company) => {
      if (company.companyName === dropdownCompany.companyName) {
        let permisos = allPermissions.find((role) => role.roleId === selectedRoleId)
        company.roleId = selectedRoleId
        company.roleName = selectedRolId.name
        company.permissions = (permisos) ? permisos.permissions : company.permissions
      }
      return company
    });

    setCompaniesRolesByUserState(updateRolesCompaniesState);
  };

  const onSaveNewCompaniesRoles = () => {
    let res = companiesRolesByUserState.map((item) => {
      return { idCompany: item.companyId, role: item.roleId };
    });

    let body = {
      email: selectedUser.email,
      userRoles: res,
    };

    saveNewCompaniesRolesForUser(token, body);
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationEnterpriseAssignView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="userAdministrationEnterpriseAssignView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              selectedUser.firstName !== "" ||
                (selectedUser.firstName !== null &&
                  selectedUser.firstLastName !== "" &&
                  selectedUser.secondLastName !== "")
                ? `${t("userAdministrationEnterpriseView.title.companies.to")} ${selectedUser.name}`
                : t("userAdministrationEnterpriseView.title.assign.companies")
            }
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow
            informationIcon={false}
            justShowImg
            openTooltipDescription={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="UserAdministrationEnterpriseAssignView-body"
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationEnterpriseAssignView-form"
          >
            {companiesRolesByUserState &&
              companiesRolesByUserState.length &&
              companiesRolesByUserState.map((company) => {
                return (
                  <>
                    <DropDownBtnHLPure
                      key={`${company.companyId}-${forceRenderKey}`}
                      labelDropDown={company.companyName}
                      optionsDropDown={listOptions}
                      onDropDownChange={(e) => handleDropDownChange(e, company)}
                      optionsValue={company.roleId}
                      valueItem={"id"}
                      nameOption={"name"}
                      subLabel={company.isExclusive ? t("company.exclusive-use") : t("company.common-use")}
                      tooltipShowSubLabel
                      positionTooltipSubLabel="right"
                      titleTooltipSubLabel={company.isExclusive ? t("company.exclusive-use") : t("company.common-use")}
                      descriptionTooltipSubLabel={company.isExclusive ? t("userAdministrationAddNewUserView.assign.exclusive.description") : t("userAdministrationAddNewUserView.assign.common.description")}
                      informationIconSubLabel
                      flex
                    />
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="userAdministrationEnterpriseAssignView-checkboxGrid"
                    >
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.consult")}
                        checkedState={company.permissions.wacth}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.contracts")}
                        checkedState={company.permissions.contratcs}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.metadata")}
                        checkedState={company.permissions.editMetadata}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.play")}
                        checkedState={company.permissions.play}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.print")}
                        checkedState={company.permissions.print}
                      />
                      <br></br>
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.download")}
                        checkedState={company.permissions.download}
                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.share")}
                        checkedState={company.permissions.share}

                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.send")}
                        checkedState={company.permissions.sendMail}

                      />
                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.upload")}
                        checkedState={company.permissions.upload}
                      />

                      <CheckBoxDownHLPure
                        setReverse
                        labelCheckBox={t("userAdministrationEnterpriseView.actions.alerts")}
                        checkedState={company.permissions.alerts}
                      />
                    </Grid>
                  </>
                );
              })}
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationEnterpriseAssignView-btnGroup"
          >
            <Grid className="userAdministrationEnterpriseAssignView-spaceBtns">
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={
                  showDetailComponent
                    ? toggleShowDetailComponent
                    : hideShowDetails
                }
              />
            </Grid>
            <ButtonHLPure
              primary
              nameBtn={t("button.save")}
              onClickBtn={onSaveNewCompaniesRoles}
            />
          </Grid>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompleteCloseDialog}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={() => toggleWarningRequesting(false, "")}
            message={message}
          />
        </Grid>
      </>
    </Grid>
  );
};

export default UserAdministrationEnterpriseView;
